import React from 'react';
import { ContentHubItemContainer, StyledContentHubItem, ContentHubIcon, StyledContentHubName, StyledContentHubCount } from './styled';

const ContentHubItem = ({ data = {} }) => {
  const { name, num_contents, logo_url } = data;
  return (<ContentHubItemContainer>
    <ContentHubIcon logo_url={logo_url} />
    <StyledContentHubItem>
      <StyledContentHubName>{name}</StyledContentHubName>
      <StyledContentHubCount>{`${num_contents} Content Pieces`}</StyledContentHubCount>
    </StyledContentHubItem>
  </ContentHubItemContainer>);
};

export default ContentHubItem;
